import axios from 'axios';
import { useLoaderData } from 'react-router';

import {
  Button,
  MortgageHeader,
} from '@elevationscu/ui-component-lib';

import { TitleBanner } from '../components';
import { AmortizationTable } from '../components/AmortizationTable/AmortizationTable';
import '../styles/common.scss';
import { NewUser } from './New';

function ExistingUser() {
  const applyLink = 'https://applymortgage.elevationscu.com/#/milestones';
  const isMobile = false;
  const {
    loDetails,
  } = useLoaderData();

  return (
    <main>
      <div className="headerDiv hide-on-print">
        <MortgageHeader />
      </div>
      <span className="hide-on-print">
        <span className={isMobile ? 'mobileHeaderApplyButton' : 'headerApplyButton'}>
          {/* TODO: Apply link used to include lo referrer, who is the new referrer (see prospect ui)? */}
          <Button id="apply_btn_top" url={`${applyLink}`}>Apply now</Button>
        </span>
      </span>
      <TitleBanner loDetails={loDetails} />
      <div>Existing User Route</div>
      <AmortizationTable
        loanAmount={500000}
        interestRate={7}
        termMonths="360"
        amortization="1"
        propertyValue="250000"
        estimateTipmi="Y"
        propertyTaxes={null}
        hazardInsurance={null}
        pmi={null}
      />
    </main>
  );
}

export const ExistingUserRoute = {
  path: '/table/:uniqueId',
  element: <ExistingUser />,
  loader: async ({ params }) => {
    try {
      const prospectUrl = `${process.env.REACT_APP_MCCC_API_URL}/prospect/${params.uniqueId}`;
      const response = await axios({
        method: 'get',
        url: prospectUrl,
      });

      return { ...response.data };
    } catch (error) {
      console.error('Error fetching loan officer data:', error);
      throw error;
    }
  },
  errorElement: <NewUser error />,
};

export { ExistingUser };
export default ExistingUser;
